import React, { FC } from 'react';
import { useTranslation } from "react-i18next";

interface NavigationStepsProps{
    onNext: () => void,
    onPrev: () => void,
    nextEnabled: boolean,
    prevEnabled: boolean,
    askInvoice?: boolean
}

const NavigationSteps: FC<NavigationStepsProps> = ({onNext, onPrev, nextEnabled, prevEnabled, askInvoice}) => {
    const {t} = useTranslation();
    const cssClass = "cursor-pointer inline-block mr-2 px-6 py-2.5 bg-orange-300 disabled:bg-orange-100 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-orange-400 hover:shadow-lg focus:bg-orange-400 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-orange-400 active:shadow-lg";
    return (
        <div className="flex flex-row prev-next-row">
            <button disabled={!prevEnabled} onClick={() => onPrev()} type="button"
                    className={cssClass}>
                {t('back')}
            </button>
            <button disabled={!nextEnabled} onClick={() => onNext()} type="button"
                    className={cssClass}>
                {t(askInvoice ? 'askInvoice' : 'next')}
            </button>
        </div>
    );
};

export default NavigationSteps;
